// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"3e461431","453":"0cc59ac9","705":"892aec51"}[chunkId] + ".chunk.js";
};